(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jeannette-chat"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('jn-faq-chat'))customElements.define('jn-faq-chat',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;
    const dialog=this.querySelector('dialog'),open=this.querySelector('[data-chat-open]'),response=this.querySelector('[data-chat-response]'),topics=this.querySelector('[data-chat-topics]'),reset=this.querySelector('[data-chat-reset]'),form=this.querySelector('form'),input=form.querySelector('input');
    const words=JSON.parse(this.querySelector('[data-chat-words]').textContent);
    const answers=[...this.querySelectorAll('[data-answer]')];
    const normal=text=>text.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
    const show=id=>{const answer=answers.find(a=>a.dataset.answer===id);if(!answer)return;response.replaceChildren(...[...answer.children].map(n=>n.cloneNode(true)));response.hidden=false;topics.hidden=true;reset.hidden=false;response.scrollIntoView({block:'nearest'});};
    open.addEventListener('click',()=>dialog.showModal());
    this.querySelector('[data-chat-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('close',()=>open.focus());
    dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
    topics.addEventListener('click',e=>{const b=e.target.closest('[data-topic]');if(b)show(b.dataset.topic);});
    reset.addEventListener('click',()=>{topics.hidden=false;response.hidden=true;reset.hidden=true;input.value='';topics.querySelector('button')?.focus();});
    form.addEventListener('submit',e=>{
      e.preventDefault();const text=' '+normal(input.value)+' ';if(!text.trim())return;
      const matches=answers.filter(a=>a.dataset.keywords.split(',').some(k=>k.trim()&&text.includes(' '+normal(k)+' ')));
      if(matches.length===1){show(matches[0].dataset.answer);return;}
      response.textContent=matches.length?words.ambiguous:words.fallback;response.hidden=false;reset.hidden=false;topics.hidden=matches.length===0;
      response.scrollIntoView({block:'nearest'});
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jeannette-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jn-newsletter-popup')) customElements.define('jn-newsletter-popup', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const dialog = this.querySelector('dialog');
    const start = Date.now();
    const key = 'jeannette-newsletter-choice';
    let previousFocus = null;
    let previousOverflow = '';
    let opened = false;
    const mark = value => {
      try { localStorage.setItem(key, JSON.stringify({ value, time: Date.now() })); } catch {}
    };
    const show = () => {
      if (dialog.open || document.querySelector('dialog[open]')) return;
      previousFocus = document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      opened = true;
      clearInterval(this.timer);
    };
    const eligible = () => {
      if (opened || this.dataset.subscribed === 'true') return false;
      try {
        const state = JSON.parse(localStorage.getItem(key) || 'null');
        if (state && (state.value === 'subscribed' || Date.now() - state.time < 7 * 864e5)) return false;
      } catch {}
      return true;
    };
    const attempt = () => {
      if (this.dataset.autoEnabled !== 'true' || !eligible()) { clearInterval(this.timer); return; }
      if (Date.now() - start > 120000) { clearInterval(this.timer); return; }
      if (document.hidden || Date.now() - start < Number(this.dataset.delay) * 1000) return;
      if (document.activeElement?.matches('input,textarea,select') || document.querySelector('dialog[open]')) return;
      const consent = document.querySelector('.shopify-pc__banner__dialog');
      if (consent && consent.getBoundingClientRect().height > 0) return;
      show();
    };
    this.querySelectorAll('[data-signup-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow;
      mark(this.querySelector('[data-signup-success]') ? 'subscribed' : 'dismissed');
      previousFocus?.focus?.({ preventScroll: true });
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    this.onOpen = event => {
      if (event.target.closest('[data-jn-newsletter-open]')) { event.preventDefault(); show(); }
    };
    document.addEventListener('click', this.onOpen);
    this.timer = setInterval(attempt, 1000);
    if (this.querySelector('[data-signup-success]')) { mark('subscribed'); show(); }
    else if (this.querySelector('[data-signup-errors]') || new URLSearchParams(location.search).get('newsletter') === '1') show();
    this.restoreOverflow = () => { if (dialog.open) document.documentElement.style.overflow = previousOverflow; };
  }
  disconnectedCallback() {
    document.removeEventListener('click', this.onOpen);
    clearInterval(this.timer);
    this.restoreOverflow?.();
    this.ready = false;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jeannette-promotion"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('jn-promotion'))customElements.define('jn-promotion',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';const key='jn-promotion-'+this.dataset.campaign;try{this.hidden=sessionStorage.getItem(key)==='closed';}catch(e){}this.querySelector('button').addEventListener('click',()=>{this.hidden=true;try{sessionStorage.setItem(key,'closed');}catch(e){}});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jeannette-welcome"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {const trigger=event.target.closest('[data-jn-open]');if(trigger){const dialog=document.getElementById(trigger.dataset.jnOpen);if(dialog&&!dialog.open)dialog.showModal();}});
document.addEventListener('click', event => {if(event.target.matches('.jn-welcome-dialog')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();}});

  } catch(e) { console.error(e); }
})();
})();
